import * as constants from "./constants";

const initialState = {
  allAutoAssign: [],
  scheduleMin: null,
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
  search: {},
};

const AutoAssignReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_AUTO_ASSIGN:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_AUTO_ASSIGN_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allAutoAssign: action.data,
      };

    case constants.FETCH_AUTO_ASSIGN_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };

    case constants.FETCH_AUTO_ASSIGN_TIME:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_AUTO_ASSIGN_TIME_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        scheduleMin: action.data,
      };

    case constants.FETCH_AUTO_ASSIGN_TIME_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };

    case constants.CREATE_AUTO_ASSIGN:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.CREATE_AUTO_ASSIGN_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allAutoAssign: [action.data, ...state.allAutoAssign],
        isAdding: false,
      };
    case constants.CREATE_AUTO_ASSIGN_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_AUTO_TIME:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_AUTO_TIME_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        scheduleMin: action.data,
        isAdding: false,
      };
    case constants.UPDATE_AUTO_TIME_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_AUTO_NOW:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_AUTO_NOW_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_AUTO_NOW_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_AUTO_ASSIGN:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_AUTO_ASSIGN_SUCCESS:
      const updated = state.allAutoAssign.map((el) =>
        el._id === action.data._id ? { ...el, ...action.data } : el
      );
      return {
        ...state,
        allAutoAssign: updated,
        updateLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_AUTO_ASSIGN_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };
    case constants.SET_AUTO_MANAGER_STATE:
      const { search } = state;

      localStorage.setItem(
        "autoManagerState",
        JSON.stringify({ search, ...action.data })
      );
      return {
        ...state,
        ...action.data,
      };

    default:
      return state;
  }
};

export default AutoAssignReducer;
